import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/TopNotice.css'

export default function TopNotice() {
  const [scrollingText, setScrollingText] = useState([]);

  const fetchNotice = useCallback(async () => {
    try {
      const response = await fetch(`/api/getWebNotice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const Data = await response.json();
        if (Data && Data.length > 0 && Data[0].Notice) {
          setScrollingText(Data[0].Notice);
        }
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, []);

  useEffect(() => {
    fetchNotice();
  }, [fetchNotice]);

  return (
    <>
      <div className="top-notice">
        <div className="non-scrolling-text">Latest News</div>
        <div className="scrolling-container">
          {scrollingText.length > 0 && <span className="scrolling-text">
            {scrollingText}</span>}
        </div>
        <div className='login-box d-flex justify-content-end' style={{ backgroundColor: '#0A1F44' }}>
          <Link to="/LogIn" className="text-white mx-2">LogIn<i className="bi bi-box-arrow-in-right fs-6"></i></Link>
        </div>
      </div>
    </>
  )
}
